import { addEasing } from "@tsparticles/engine";
export async function loadEasingLinearPlugin() {
    addEasing("ease-in-linear", (value) => {
        return value;
    });
    addEasing("ease-out-linear", (value) => {
        return value;
    });
    addEasing("ease-in-out-linear", (value) => {
        return value;
    });
}
